import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=33d07fed&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
